(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    

  var headers = document.querySelectorAll(".tab-header");
  var activeTab;
  for (i = 0; i < headers.length; i++) {
    (function(i) {
      headers[i].addEventListener('click', function() {
        try {
          activeTab = document.querySelector(".tab-content.active");
        } catch (error) {
          activeTab = null;
        }
        if (activeTab !== null) {
          activeTab.classList.remove("active");
        }
        if (activeTab !== headers[i].nextElementSibling) {
          headers[i].nextElementSibling.classList.toggle("active");
        } else {
          headers[i].nextElementSibling.classList.remove("active");
        }
      });
    })(i);
  }

  function updateTop() {
    document.getElementById("product-form").style.top = document.getElementById("shopify-section-header").offsetHeight + "px";
  }

  window.addEventListener('DOMContentLoaded', updateTop());
  window.addEventListener('resize', updateTop());


  } catch(e) { console.error(e); }
})();
})();
